import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

const SubActionButton = ({
  id,
  iconPath,
  isShown,
  text,
  onClick,
  smallerText,
}) => {
  const defaultIconPath = '/images/icons/subActions/settings-icon.svg';

  if (!isShown) {
    return null;
  }

  return (
    <button
      className={cn({
        [styles.button]: true,
        [styles.smallerButtonText]: smallerText,
      })}
      type="button"
      onClick={() => onClick(id)}
    >
      <div className={styles.circle}>
        <img className={styles.icon} src={iconPath || defaultIconPath} alt="" />
      </div>
      <div className={styles.text}>{text}</div>
    </button>
  );
};

export default SubActionButton;
